import { type MouseEvent, useCallback, useState } from 'react';

import { downloadFile, toasterError } from '../../../helpers';
import { downloadLpcoData } from '../services/lpco';

const useDownloadLicense = (id: string, isPreview = false) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadLicense = useCallback(
    async (e: MouseEvent) => {
      e.stopPropagation();

      if (isDownloading) {
        return;
      }

      try {
        setIsDownloading(true);
        const { data } = await downloadLpcoData(id, isPreview);
        downloadFile(data, `lpco-${id}${isPreview ? '-preview' : ''}`, 'application/pdf');
      } catch (e) {
        toasterError({ description: 'Something went wrong' });
      } finally {
        setIsDownloading(false);
      }
    },
    [id, isDownloading, isPreview]
  );

  return {
    isDownloading,
    handleDownloadLicense,
  };
};

export default useDownloadLicense;
